// Version : 0.0.2
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last Add : 'REMOVE UNUSED LINES'
// Modified Date : 06/12/2025
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import { takeLatest, put, all, call } from 'redux-saga/effects';
import GoldLoanDisbursementTypes from './gold-loan-disbursement.types';
import {
	fetchGoldLoanIndexDisbursementSuccess,
	fetchGoldLoanIndexDisbursementFailure,
	fetchGoldLoanIndexDisbursementResponseChanged,
	fetchGoldLoanIndexDisbursementListSuccess,
	fetchGoldLoanIndexDisbursementListFailure,
	fetchGoldLoanIndexDisbursementListResponseChanged,
	updateGoldLoanDisbursementSuccess,
	updateGoldLoanDisbursementFailure,
	updateGoldLoanDisbursementResponseChanged,
} from './gold-loan-disbursement.action';
import {
	fetchGoldLoanIndexDisbursement,
	fetchGoldLoanIndexDisbursementList,
	updateGoldLoanDisbursement,
} from './gold-loan-disbursement.service';

/** *********************  LOAN INDEX FETCH BASED ON GROUP LIST  ******************** */
export function* fetchGroupLoanIndexList({ payload }: any) {
	try {
		const key = 'FetchGoldLoanIndexDetailKey';
		const jsonData = {
			BranchID: payload.branchID,
			LocationID: payload.centerID,
			GroupID: payload.groupID,
			CompanyID: payload.companyID,
			DatabaseName: payload.databaseName,
			GoldLoanID: payload.goldLoanID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchGoldLoanIndexDisbursement, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchGoldLoanIndexDisbursementFailure(responseData.data));
		} else {
			yield put(fetchGoldLoanIndexDisbursementSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchGoldLoanIndexDisbursementFailure(error));
	}
}

export function* resetFetchGroupLoanIndexResponse() {
	yield put(fetchGoldLoanIndexDisbursementResponseChanged());
}

export function* onFetchGroupLoanIndexDetails() {
	yield takeLatest(
		GoldLoanDisbursementTypes.GOLD_LOAN_INDEX_DISBURSEMENT_START,
		fetchGroupLoanIndexList,
	);
}

export function* onFetchGroupLoanIndexResponseReset() {
	yield takeLatest(
		GoldLoanDisbursementTypes.GOLD_LOAN_INDEX_DISBURSEMENT_RESPONSE_RESET_START,
		resetFetchGroupLoanIndexResponse,
	);
}
/** *********************  END LOAN INDEX FETCH BASED ON GROUP LIST ******************** */

/** *********************  LOAN INDEX FETCH BASED ON GROUP LIST  ******************** */
export function* fetchGroupLoanIndexListList({ payload }: any) {
	try {
		const key = 'GoldLoanIndexListGroupKey';
		const {
			companyID,
			userLevel,
			databaseName,
			branchID,
			centerID,
			groupID,
			type,
			userID,
			userRole,
			userRoleID,
		} = payload;
		const jsonData = {
			BranchID: branchID,
			LocationID: centerID,
			GroupID: groupID,
			CompanyID: companyID,
			DatabaseName: databaseName,
			Type: type,
			UserID: userID,
			UserLevel: userLevel,
			UserRole: userRole,
			UserRoleID: userRoleID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchGoldLoanIndexDisbursementList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchGoldLoanIndexDisbursementListFailure(responseData.data));
		} else {
			yield put(fetchGoldLoanIndexDisbursementListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchGoldLoanIndexDisbursementListFailure(error));
	}
}

export function* resetFetchGroupLoanIndexListResponse() {
	yield put(fetchGoldLoanIndexDisbursementListResponseChanged());
}

export function* onFetchGroupLoanIndexList() {
	yield takeLatest(
		GoldLoanDisbursementTypes.GOLD_LOAN_INDEX_DISBURSEMENT_LIST_START,
		fetchGroupLoanIndexListList,
	);
}

export function* onFetchGroupLoanIndexListResponseReset() {
	yield takeLatest(
		GoldLoanDisbursementTypes.GOLD_LOAN_INDEX_DISBURSEMENT_LIST_RESPONSE_RESET_START,
		resetFetchGroupLoanIndexListResponse,
	);
}

/** *********************  END LOAN INDEX FETCH BASED ON GROUP LIST  ******************** */

/** *********************  UPDATE GOLD LOAN DISBURSEMENT  ******************** */
export function* updateGoldLoanDisbursementSaga({ payload }: any) {
	try {
		const key = 'UpdateGoldLoanDisbursementKey';
		const {
			companyID,
			databaseName,
			transactionType,
			funderID,
			loanIndexStatus,
			goldLoanUID,
			goldLoanID,
			loandisbursementdate,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			TransactionType: transactionType,
			FunderID: funderID,
			LoanIndexStatus: loanIndexStatus,
			GoldLoanUID: goldLoanUID,
			GoldLoanID: goldLoanID,
			Loandisbursementdate: loandisbursementdate,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateGoldLoanDisbursement, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateGoldLoanDisbursementFailure(responseData.data));
		} else {
			yield put(updateGoldLoanDisbursementSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateGoldLoanDisbursementFailure(error));
	}
}

export function* resetUpdateGoldLoanDisbursementResponse() {
	yield put(updateGoldLoanDisbursementResponseChanged());
}

export function* onUpdateGoldLoanDisbursement() {
	yield takeLatest(
		GoldLoanDisbursementTypes.UPDATE_GOLD_LOAN_DISBURSEMENT_START,
		updateGoldLoanDisbursementSaga,
	);
}

export function* onUpdateGoldLoanDisbursementResponseReset() {
	yield takeLatest(
		GoldLoanDisbursementTypes.UPDATE_GOLD_LOAN_DISBURSEMENT_RESPONSE_RESET_START,
		resetUpdateGoldLoanDisbursementResponse,
	);
}
/** *********************  END UPDATE GOLD LOAN DISBURSEMENT  ******************** */

export function* goldLoanDisbursementSaga() {
	yield all([
		call(onFetchGroupLoanIndexDetails),
		call(onFetchGroupLoanIndexResponseReset),
		call(onFetchGroupLoanIndexList),
		call(onFetchGroupLoanIndexListResponseReset),
		call(onUpdateGoldLoanDisbursement),
		call(onUpdateGoldLoanDisbursementResponseReset),
	]);
}
